var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_513_4550",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_513_4550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1 22.0001C11.8399 22.0001 10.6585 21.7623 9.55585 21.2867C8.45323 20.811 7.48943 20.1607 6.66443 19.3357C5.83943 18.5107 5.1891 17.5469 4.71345 16.4443C4.23782 15.3416 4 14.1602 4 12.9001C4 10.954 4.56026 9.19915 5.68078 7.63568C6.80129 6.07221 8.2795 4.98215 10.1154 4.36548C10.0462 5.92573 10.2853 7.42605 10.8327 8.86645C11.3801 10.3068 12.2071 11.5802 13.3135 12.6866C14.4199 13.793 15.6933 14.62 17.1337 15.1674C18.5741 15.7148 20.0744 15.9539 21.6346 15.8847C21.0218 17.7206 19.9327 19.1988 18.3673 20.3193C16.8019 21.4398 15.0462 22.0001 13.1 22.0001ZM13.1 21.0001C14.5667 21.0001 15.925 20.6334 17.175 19.9001C18.425 19.1668 19.4083 18.1567 20.125 16.8698C18.6917 16.7361 17.3333 16.3726 16.05 15.7793C14.7667 15.186 13.6167 14.3796 12.6 13.3601C11.5833 12.3406 10.775 11.1924 10.175 9.91548C9.575 8.63856 9.21667 7.28344 9.1 5.8501C7.81667 6.56677 6.8125 7.55427 6.0875 8.8126C5.3625 10.0709 5 11.4334 5 12.9001C5 15.1501 5.7875 17.0626 7.3625 18.6376C8.9375 20.2126 10.85 21.0001 13.1 21.0001Z",
    fill: "#3A5F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.0d73dde0f9793aadf246327b25af5d9b.svg";
export { ForwardRef as ReactComponent };